var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`height: ${_vm.config.height}`),attrs:{"id":"map"}},[(!!this.google && !!this.map)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }